/**
 * カレンダーの表示処理
 **/

$(document).ready(function () {
  //共通で使う変数
  var date_now = new Date();
  var date_start = new Date(date_now.getFullYear(), 0, 1);
  var date_end = new Date(date_now.getFullYear() + 1, 0, 0 + 1);
  //var date_start = new Date(date_now.getFullYear(), date_now.getMonth(), 1);
  //var date_end = new Date(date_now.getFullYear(), date_now.getMonth(), 1);
  var days = ["日", "月", "火", "水", "木", "金", "土"];
  //date_end.setMonth(date_end.getMonth()+12);

  //カレンダーの要素を探して初期化する
  $(".calendar").each(function () {
    var calendar_el = this;
    var calendar_id = $(this).data("calendar-id");
    var calendar_style = $(this).data("calendar-style");
    var calendar_month = $(this).data("calendar-month");

    console.log(
      "init calendar id=%s style=%s month=%s",
      calendar_id,
      calendar_style,
      calendar_month
    );
    initCalendar(calendar_el, calendar_id, calendar_style, calendar_month);
  });

  /**
   * カレンダーの初期化処理
   **/
  function initCalendar(calendarEl, id, style, month) {
    //共通のカレンダーオプション
    var options = {
      plugins: ["interaction", "dayGrid", "list"],
      nextDayThreshold: "00:00:00",
      timezone: "UTC",
      titleFormat: function (obj) {
        return obj.date.year + "年" + (obj.date.month + 1) + "月";
      },
      columnHeaderText: function (obj) {
        return days[obj.getDay()];
      },
      buttonText: {
        today: "今日",
        listDay: "今日",
        listWeek: "今週",
        listMonth: "今月",
      },
      contentHeight: "auto",
      displayEventTime: false,
      fixedWeekCount: false,
    };

    //スタイルタイプごとのオプション
    if (style === "type3") {
      options.showNonCurrentDates = false;
      options.defaultView = "dayGridMonth";
      options.header = {
        left: "",
        center: "title",
        right: "prev, today, next",
      };
      options.validRange = {
        start: date_start,
        end: date_end,
      };
      options.defaultDate = month;
      options.titleFormat = function (obj) {
        return obj.date.month + 1;
      };
      options.eventRender = function (info) {
        info.el.querySelector(".fc-title").innerHTML =
          "<div class='Character-image'>" + info.event.title + "</div>";
      };
      options.buttonText = {
        today: "今月",
      };
    } else if (style === "type2") {
      options.defaultView = "listWeek";
      options.locale = "Ja";
      options.listDayFormat = {
        month: "long",
        year: "numeric",
        day: "numeric",
      };
      options.header = {
        left: "",
        center: "listDay,listWeek,listMonth",
        right: "",
      };
    } else {
      options.defaultView = "dayGridMonth";
      options.header = {
        left: "",
        center: "title",
        right: "today, prev, next",
      };
    }

    // イベント取得
    try {
      var eventVarName = "__moko_calendar_events_" + id;
      if (typeof window[eventVarName] !== "undefined") {
        options.events = window[eventVarName];
      } else {
        console.warn("Calendar events not found for ID:", id);
        options.events = [];
      }
    } catch (e) {
      console.error("Error loading calendar events:", e);
      options.events = [];
    }

    //
    // Uncaught ReferenceError: FullCalendar is not defined
    // が発生するため初期タイミングをずらす
    setTimeout(function () {
      var calendar = new FullCalendar.Calendar(calendarEl, options);
      calendar.render();
    }, 100);
  }
});
